import classNames from "classnames";
import { useContext } from "react";
import { MoonStarsFill, SunFill } from "react-bootstrap-icons";
import { setUserTheme, ThemeContext } from "./UserTheme";
import { Button } from "./UiComponents/button";

// ThemeButton component allows users to toggle between light and dark themes
export function ThemeButton(): JSX.Element {
  // Access the current theme and the function to set the theme from the context
  const { theme, setTheme } = useContext(ThemeContext);

  // Function to toggle between light and dark themes
  const toggleTheme = () => {
    // Determine the new theme based on the current theme
    let newTheme: ('light' | 'dark') = theme === 'light' ? 'dark' : 'light';

    // Update the user's preferred theme
    setUserTheme(newTheme);

    // Set the theme in the context
    setTheme(newTheme);
  };

  // Define CSS classes for the theme icon
  const iconClasses = classNames('h-5 w-5 mr-1 inline text-usfApple');

  // Define CSS classes for the theme text
  const textClasses = classNames('text-white hover:underline text-sm lg:text-lg');

  // Determine the inner content of the button based on the current theme
  const inner = theme === 'light'
    ? <SunFill className={iconClasses} />
    : <MoonStarsFill className={iconClasses} />

  // Render the theme button with the appropriate icon and text
  return (
    // Did not use <Button></Button> component because it will mess up other buttons/links in Navbar
    <abbr title={theme === "light" ? "Click to change to dark theme" : "Click to change to light theme"}>
      <button
        onClick={toggleTheme}
      >
        {inner}
        <span className={textClasses}>
          {theme === 'light' ? 'Dark Theme' : 'Light Theme'}
        </span>
      </button>
    </abbr>
  );
}
